import React from 'react';
import { motion} from "framer-motion"

import banner from '../../../assest/banner1/banner1.jpg.jpg'
const Banner = () => {
  function slideInFromLeft(number) {
    return {
      hidden: { x: -100, opacity: 0 },
      visible: {
        x: 0,
        opacity: 1,
        transition: {
          delay:number,
          duration: 0.5,
        },
      },
    };
  }
 

  
  return (
       <motion.div initial="hidden"
       animate="visible">

        
      
         <motion.div    className="hero h-[500px] " style={{
           background:`url(${banner})`,
           backgroundSize:'cover',
        }}>
  <div div className="hero-overlay bg-opacity-60" ></div>
  <div className="hero-content text-center text-neutral-content">
    <motion.div variants={ slideInFromLeft(0.5)
      } className="max-w-[700px] mx-auto ">
      <h1 className="mb-5 text-[30px] leading-[40px] lg:text-[48px] lg:leading-[58px] text-center font-bold">OUR <span className='text-primary'>PARTS</span>  </h1>
      <p  className="mb-5 text-[18px] leading-[28px]">At our store, we provide the best car parts to ensure your vehicle runs smoothly and efficiently.We pride ourselves on providing the best car parts, guaranteeing quality and durability for all your automotive needs.</p>
        
    </motion.div>
  </div>
</motion.div>



       </motion.div>
    );
};

export default Banner;